<template lang="pug">
    div.hidden
        el-form-item(prop="gender")
        el-form-item(prop="first_name")
        el-form-item(prop="last_name")
        el-form-item(prop="email")
        el-form-item(prop="password")
        div(v-for="(address, index) in addresses")
            el-form-item(:prop="'addresses.' + index + '.street'")
            el-form-item(:prop="'addresses.' + index + '.zipcode'")
            el-form-item(:prop="'addresses.' + index + '.city'")
            el-form-item(:prop="'addresses.' + index + '.country'")
                el-form-item(v-if="addresses.length > 1" :prop="'addresses.' + index + '.defaultSwitches'")
        //- div(v-for="(administrator, index) in administrators")
        //-     el-form-item(:prop="'administrators.' + index + '.cms.name'")
        //-     el-form-item(:prop="'administrators.' + index + '.cms.config.template'")
        //-     div(v-if="administrator.domains && administrator.domains.length" v-for="(domain, d) in administrator.domains")
        //-         el-form-item(:prop="'administrators.' + index + '.domains.' + d + '.base_url'")
</template>

<script>

import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
    name: 'AllInputFields',
    computed: {
        addresses() {
            return _.get(this.form, 'addresses') || []
        },
        // administrators() {
        //     return _.get(this.form, 'administrators') || []
        // },
        ...mapGetters({
            form: 'account/form',
        }),
    }
}
</script>
